// extracted by mini-css-extract-plugin
export default {"companyBox":"CityInquiry_companyBox__f6mdK"};